import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import SFUseStyled from "../../areas/core/hooks/useStyled";
import SFTypography from "../../areas/core/components/typography";
import { SFStack } from "@sf-core";
import { useTranslation } from "react-i18next";

const { styled } = SFUseStyled();

const DialogStyled = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    backgroundColor: theme.palette.grey450.main,
    color: theme.palette.grey50.main,
    borderRadius: "6px",
  },
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.grey400.main,
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  padding: theme.spacing(2.5),
  paddingLeft: theme.spacing(3),
  ...theme.typography.cardTitle,
  ...theme.typography.bold,
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(3),
  paddingTop: theme.spacing(0),
}));

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  marginTop: theme.spacing(1),
  padding: theme.spacing(2.5),
  paddingLeft: theme.spacing(4),
  justifyContent: "space-between",
  boxShadow: "0px -5px 16px 0px rgba(0, 0, 0, 0.15)",
}));

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: "white",
  "&.Mui-checked": {
    color: theme.palette.blue200.main,
  },
}));

const CookiesPopup = (props) => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);
  const scrollproperty = "paper";
  return (
    <DialogStyled
      open={props.open}
      onClose={props.onClose}
      scroll={scrollproperty}
      maxWidth={props.size}
    >
      <StyledDialogTitle>
        <SFTypography variant="academyCardTitle">{props.header}</SFTypography>
      </StyledDialogTitle>
      <StyledDivider />
      <StyledDialogContent>
        <SFTypography variant="body1">
          {props.children}
        </SFTypography>
      </StyledDialogContent>
      {(props.actionAccept || props.actionClose || props.checkLabel) && (
        <StyledDialogActions>
          <SFStack direction="row" alignItems="center">
            {props.checkLabel && (
              <FormControlLabel
                control={
                  <StyledCheckbox
                    onChange={() => {
                      setChecked(!checked);
                    }}
                    checked={checked}
                  />
                }
                label={<SFTypography variant="body1">{props.checkLabel}</SFTypography>}
              />
            )}
          </SFStack>
          <SFStack direction="row" alignItems="center" spacing={2}>
            {props.actionClose && (
              <Button variant="transparent" onClick={props.actionClose}>
                <SFTypography>{t("policies.popup.closeBtn")}</SFTypography>
              </Button>
            )}
            {props.actionDecline && (
              <Button variant="transparent" onClick={props.actionDecline}>
                <SFTypography>{t("policies.popup.declineBtn")}</SFTypography>
              </Button>
            )}
            {props.actionAccept && (
              <Button
                variant="secondary"
                onClick={props.actionAccept}
                disabled={props.checkLabel && !checked}
              >
                <SFTypography> {t("policies.popup.acceptBtn")} </SFTypography>
              </Button>
            )}
          </SFStack>
        </StyledDialogActions>
      )}
    </DialogStyled>
  );
};

export default CookiesPopup;
